import type { ViewerPluginCreator } from 'wix-rich-content-common';

import { DEFAULTS } from './consts';
import type { ImagePluginViewerConfig } from './types';
import { IMAGE_TYPE } from './types';
export { IMAGE_TYPE, ImagePluginViewerConfig };
import { nodeViewRenderers } from './viewer/node-view-renderers-loadable';

export const pluginImage: ViewerPluginCreator<ImagePluginViewerConfig> = config => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: IMAGE_TYPE,
    nodeViewRenderers,
  };
};
